"use memo"

import {
  AgxSpacer,
  AgxToggleSwitch,
  AgxTypography,
} from '@urbanx/agx.ui-components2'
import { TaskModalPageProps } from './TaskModalPageProps'
import { useCallback } from 'react'
import { TaskStepDto } from '@urbanx/agx.activities.client'

interface TaskModalStepToggleProps extends TaskModalPageProps {
  step: TaskStepDto
}

const TaskModalStepToggle = ({
  toggleTaskStep,
  step,
}: TaskModalStepToggleProps) => {
  const onToggleChange = useCallback(
    (isChecked: boolean) => {
      toggleTaskStep(step.order ?? 0, isChecked)
    },
    [toggleTaskStep, step.order]
  )

  return (
    <AgxSpacer
      direction="horizontal"
      gap="spacing-lg"
      contentJustification="space-between"
      contentAlignment="start"
      fill
    >
      {/* Top padding visually centres the first text line against the toggle */}
      <AgxSpacer direction="vertical" padding={{ top: 'spacing-xs' }}>
        <AgxTypography
          id={`step-${step.name}`}
          type={'body_ui'}
          size={'medium'}
          color="var(--text-primary)"
        >
          {step.name}
        </AgxTypography>
      </AgxSpacer>
      <AgxToggleSwitch
        id={`step-${step.name}`}
        checked={step.isCompleted ?? false}
        onChange={(isChecked: boolean) => onToggleChange(isChecked)}
      />
    </AgxSpacer>
  )
}

export default TaskModalStepToggle
